import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { globalPlayerIdAtom, hasUserSelectedPlayerAtom } from '@/atoms/player/player';
import { globalTeamIdAtom, hasUserSelectedTeamAtom } from '@/atoms/team/team';

/**
 * Switches the 'context' of the application to be team-focused when a user selects a team. Users can do this by
 * navigating directly to a team url, searching for a team or clicking a team link.
 */
export const useSetUserTeamSelectedAtom = () => {
  const globalTeamId = useAtomValue(globalTeamIdAtom);
  const setHasUserSelectedTeam = useSetAtom(hasUserSelectedTeamAtom);
  const setGlobalPlayerId = useSetAtom(globalPlayerIdAtom);
  const setHasUserSelectedPlayer = useSetAtom(hasUserSelectedPlayerAtom);

  useEffect(() => {
    if (globalTeamId) {
      setHasUserSelectedTeam(true);
      // Clears any existing player context - we're using a team perspective now
      setGlobalPlayerId(null);
      setHasUserSelectedPlayer(false);
    }
  }, [globalTeamId]);
};
